var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterOnCircle = function SvgFilterOnCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.13,
    cy: 4.378,
    r: 4,
    fill: "#00CA72"
  })));
};
export default SvgFilterOnCircle;